import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { PageHeaderSection } from "../../components/common/PageHeadSection";
import { Skeleton } from "antd";
import _ from "lodash";
import { SFModal } from "../../components/elements/SFModal";
import { mdlOffer } from "../../models/domain/Offer";
import { OfferService } from "../../services/OfferService";
import { mdlOfferListRequest } from "../../models/service-models/offer/OfferListRequest";
import { OfferTable } from "../../components/offer/OfferTable";
import { enmOfferAnswerType } from "../../models/enums/OfferAnswerType";
import { OfferDetail } from "../../components/offer/OfferDetail";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { HeaderButton } from "../../models/ui-models/HeaderButton";

export const OfferList = () => {
    const { t } = useTranslation();
    const [selectedOffer, setSelectedOffer] = useState<mdlOffer>();
    const [request, setRequest] = useState<mdlOfferListRequest>();
    const [openModalDetail, setOpenModalDetail] = useState<boolean>(false);

    useEffect(() => {
        if (!offerList) {
            refetchOfferList();
        }
    }, []);

    const {
        data: offerList,
        isLoading: isLoadingOfferList,
        refetch: refetchOfferList
    } = useQuery(
        ["offerList"],
        () => {
            return OfferService.List({ ...request });
        },
        {
            refetchOnWindowFocus: false,
            enabled: false,
        }
    );

    const handleOfferSelect = (record: mdlOffer) => {
        setSelectedOffer(record);
        setOpenModalDetail(true);
    }

    const handleModalClose = (refresh: boolean) => {
        setOpenModalDetail(!openModalDetail)
        if (openModalDetail) {
            setSelectedOffer(undefined);
        }
        if (refresh === true) {
            refetchOfferList();
        }
    }

    const handleRefresh = () => {
        refetchOfferList();
    }

    const getButtons = (): HeaderButton[] | undefined => {
        let _buttons: HeaderButton[] = [];
        _buttons.push({
            title: t("offer.refresh"),
            icon: faRefresh,
            fnFunction: handleRefresh,
            className: "btn btn-white btn-dim btn-outline-primary"
        });
        return _buttons;
    }

    return (
        <>
            <SFModal
                toggler={handleModalClose}
                width={window.innerWidth * 80 / 100}
                open={openModalDetail}
                body={<OfferDetail offer={selectedOffer} callback={handleModalClose} />}
                title={t("common.detail")}
            />
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("offer.offerList")}
                                buttons={getButtons()}
                            />
                            <div className="row">
                                <div className="col mt-2">
                                    <div className="card card-bordered h-100">
                                        <div className="card-inner">
                                            <div className="project-info mb-4">
                                                <h6 className="title">{t("offer.waitingOffers")}</h6>
                                            </div>
                                            {
                                                isLoadingOfferList
                                                &&
                                                <>
                                                    <Skeleton active />
                                                    <Skeleton active />
                                                    <Skeleton active />
                                                </>
                                            }
                                            {
                                                !isLoadingOfferList && offerList &&
                                                <OfferTable
                                                    onTableItemSelect={handleOfferSelect}
                                                    tableItems={offerList?.body?.data?.filter(x => x.isAnswered == enmOfferAnswerType.None)} />
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="col mt-2">
                                    <div className="card card-bordered h-100">
                                        <div className="card-inner">
                                            <div className="project-info mb-4">
                                                <h6 className="title">{t("offer.myOffers")}</h6>
                                            </div>
                                            {
                                                isLoadingOfferList
                                                &&
                                                <>
                                                    <Skeleton active />
                                                    <Skeleton active />
                                                    <Skeleton active />
                                                </>
                                            }
                                            {
                                                !isLoadingOfferList && offerList &&
                                                <>
                                                    <OfferTable
                                                        onTableItemSelect={handleOfferSelect}
                                                        tableItems={offerList?.body?.data?.filter(x => x.isAnswered != enmOfferAnswerType.None)} />
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};